import React, { useState } from "react";
import { FaX } from "react-icons/fa6";
import Button from "../../../../components/button-v1/index";
import CustomInput from "../../../../components/ui/input";
import styles from "./addCategoryModal.module.css";

const AddCategoryModal = ({ open, onClose, onAddCategory }) => {
  const [categoryName, setCategoryName] = useState("");

  if (!open) return null;

  const handleAdd = () => {
    const trimmed = categoryName.trim();
    if (trimmed) {
      onAddCategory(trimmed);
      setCategoryName("");
      onClose();
    }
  };

  const isDisabled = !categoryName.trim();

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>Add New Category</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <FaX />
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.field}>
            <label className={styles.label}>Category Name</label>
            <CustomInput
              placeholder="e.g., Sleep Apnea"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
            />
          </div>
        </div>

        <div className={styles.footer}>
          <Button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button
            className={styles.actionButton}
            onClick={handleAdd}
            disabled={isDisabled}
          >
            Add Category
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddCategoryModal;